import EntityAudit from "./EntityAudit";

export default EntityAudit;